var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"block"},[_c('div',{staticClass:"block__title",domProps:{"textContent":_vm._s(_vm.props.title)}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }